export default function($form) {
  let extForm = $form.getExtForm();
  let businessId = extForm.businessId;//秘书代录子流程打开流程图需要显示主流程图，所以不传流程定义Id
  let processDefinitionId =  (!window.$Env || !$Env.flowImageNotPassProcessDefinitionId || !businessId) ? extForm.processDefinitionId : '';
  let applicationId = extForm.appId;
  PF.func.bpm.showFlowImage({
    businessId:businessId,
    batchId: extForm.batchId,
    processDefinitionId: processDefinitionId,
    applicationId: applicationId
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-show-flow-image.js